//  @flow

import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router';
import type { State } from 'types/redux';
import { injectIntl } from 'react-intl';

// Components
import Profile from './Profile';

// Actions
import { goTo } from 'store/reducers/navigation/actions';
import { gtmUserEvent } from 'store/reducers/gtm/actions';
import { updateProfile } from 'store/reducers/user/personInfo/actions';
import {
  setFirstName,
  setLastName,
  setEmail,
  setPhoneNumber,
  setMobilePhoneNumber
} from 'store/reducers/appointment/actions';
import {
  setStreetAddressOne,
  setStreetAddressTwo,
  setCity,
  setStateAddress,
  setPostalCode,
  setCountry
} from 'store/reducers/appointment/contactInfo/address/actions';

// Selector
import {
  getPersonInfo,
  getProfileInitialValues
} from 'store/reducers/user/personInfo/selectors';
import { selectors as socialSelectors } from 'store/reducers/user/social/';
import {
  getDealerCountryCode,
  getSupportedCountries
} from 'store/reducers/dealerSettings/selectors';
import { getAddress } from 'store/reducers/appointment/contactInfo/address/selectors';
import { getCountryStates } from 'store/reducers/states/actions';
import { getStates } from 'store/reducers/states/selectors';

const mapStateToProps = (state: State) => ({
  personInfo: getPersonInfo(state),
  isSocialLogin: socialSelectors.getPartialSignInProvider(state),
  countryCode: getDealerCountryCode(state),
  address: getAddress(state),
  countries: getSupportedCountries(state),
  profileInitialValues: getProfileInitialValues(state),
  states: getStates(state)
});

export default compose(
  withRouter,
  injectIntl,
  connect(
    mapStateToProps,
    {
      goTo,
      gtmUserEvent,
      updateProfile,
      setFirstName,
      setLastName,
      setEmail,
      setPhoneNumber,
      setMobilePhoneNumber,
      setStreetAddressOne,
      setStreetAddressTwo,
      setCity,
      setStateAddress,
      setPostalCode,
      setCountry,
      getCountryStates
    }
  )
)(Profile);



// WEBPACK FOOTER //
// ./src/components/pages/User/Profile/ProfileContainer.js